import type { OrderSource } from "./order-source";
import { ORDER_SOURCE_IDS } from "@/services/orders/orders.types";
import { itoStatusLabelFor } from "../order-display.mapper";
import { OrdersService } from "@/services/orders/orders-service";

let ordersService: OrdersService | undefined;
const getOrdersService = (): OrdersService => (ordersService ??= new OrdersService());

export const itoOrderSource: OrderSource = {
  id: ORDER_SOURCE_IDS.ito,
  isEnabled: () => true,
  fetch: async () => {
    const response = await getOrdersService().getMyOrders();
    return (response.orders ?? []).map((order) => ({
      ...order,
      source: ORDER_SOURCE_IDS.ito,
      statusLabel: itoStatusLabelFor(order.status),
    }));
  },
};
